import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// NOTE: Do NOT set token here at module load time.
// AuthContext handles setting/clearing the axios default header on login/logout.

const getRestaurantId = () => localStorage.getItem('restaurant_id') || '';

export const api = {
  // ── Auth ──
  login: (email, password) => axios.post(`${API_URL}/auth/login`, { email, password }),
  getMe: () => axios.get(`${API_URL}/auth/me`),
  changePassword: (current_password, new_password) =>
    axios.post(`${API_URL}/auth/change-password`, { current_password, new_password }),
  getUsers: () => axios.get(`${API_URL}/users`),
  registerUser: (data) => axios.post(`${API_URL}/auth/register`, data),
  deleteUser: (user_id) => axios.delete(`${API_URL}/users/${user_id}`),
  adminChangeUserPassword: (user_id, new_password) =>
    axios.put(`${API_URL}/users/${user_id}/password`, { new_password }),

  // ── Categories ──
  getCategories: (restaurantId) =>
    axios.get(`${API_URL}/categories`, { params: { restaurant_id: restaurantId || getRestaurantId() } }),
  createCategory: (name) => axios.post(`${API_URL}/categories`, { name }),
  updateCategory: (id, name) => axios.put(`${API_URL}/categories/${id}`, { name }),
  deleteCategory: (id) => axios.delete(`${API_URL}/categories/${id}`),

  // ── Menu ──
  getMenu: (restaurantId) =>
    axios.get(`${API_URL}/menu`, { params: { restaurant_id: restaurantId || getRestaurantId() } }),
  createMenuItem: (data) => axios.post(`${API_URL}/menu`, data),
  updateMenuItem: (id, data) => axios.put(`${API_URL}/menu/${id}`, data),
  deleteMenuItem: (id) => axios.delete(`${API_URL}/menu/${id}`),

  // ── Tables ──
  getTables: (restaurantId) =>
    axios.get(`${API_URL}/tables`, { params: { restaurant_id: restaurantId || getRestaurantId() } }),
  generateTables: () => axios.post(`${API_URL}/tables/generate`),

  // ── Orders ──
  createOrder: (data, restaurantId) =>
    axios.post(`${API_URL}/orders`, data, { params: { restaurant_id: restaurantId } }),
  getOrders: (status) =>
    axios.get(`${API_URL}/orders${status ? `?status=${status}` : ''}`),
  updateOrderStatus: (id, status, cancelled_by = null) =>
    axios.put(`${API_URL}/orders/${id}`, { status, ...(cancelled_by && { cancelled_by }) }),
  cancelOrderByCustomer: (id, restaurantId) =>
    axios.put(`${API_URL}/orders/${id}/cancel`, {}, { params: { restaurant_id: restaurantId } }),
  deleteOrder: (id) => axios.delete(`${API_URL}/orders/${id}`),

  // ── Order History ──
  getOrderHistory: () => axios.get(`${API_URL}/order-history`),
  deleteOrderHistory: (id) => axios.delete(`${API_URL}/order-history/${id}`),

  // ── Billing ──
  getBillingRecords: () => axios.get(`${API_URL}/billing`),
  createBillingRecord: (data) => axios.post(`${API_URL}/billing`, data),
  deleteBillingRecord: (id) => axios.delete(`${API_URL}/billing/${id}`),

  // ── CRM — Customer Profiles ──
  getCustomers: () => axios.get(`${API_URL}/customers`),
  exportCustomersCSV: () =>
    axios.get(`${API_URL}/customers/export`, { responseType: 'blob' }),

  // ── Settings ──
  getUpiSettings: () => axios.get(`${API_URL}/settings/upi`),
  saveUpiSettings: (data) => axios.put(`${API_URL}/settings/upi`, data),
  getRestaurantProfile: () => axios.get(`${API_URL}/settings/profile`),
  saveRestaurantProfile: (data) => axios.put(`${API_URL}/settings/profile`, data),

  // ── Messages ──
  getMessages: () => axios.get(`${API_URL}/messages`),
  sendMessage: (message) => axios.post(`${API_URL}/messages`, { message }),
};

export default api;
